import { render, staticRenderFns } from "./official-academic-transcript.vue?vue&type=template&id=4aed3a32"
import script from "./official-academic-transcript.vue?vue&type=script&lang=js"
export * from "./official-academic-transcript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports